import React from 'react'

function Scroll(props){
    return (
        // you can also add style like this
        <div style={{}}>
            {props.children}
        </div>
    )
}

export default Scroll